export default "__VITE_ASSET__Drs5p79j__"